import { render, staticRenderFns } from "./CommitToGithub.vue?vue&type=template&id=6950cfc2&scoped=true&"
import script from "./CommitToGithub.vue?vue&type=script&lang=js&"
export * from "./CommitToGithub.vue?vue&type=script&lang=js&"
import style0 from "./CommitToGithub.vue?vue&type=style&index=0&id=6950cfc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950cfc2",
  null
  
)

export default component.exports